<template lang="html">
  <div id="drones-page">
    <section class="pt-5 pb-5 products-section" style="background-color: #f8fffc;">
      <div class="container">
        <!-- Header -->
        <div class="text-center mb-4">
          <h1 class="h2 font-weight-bold text-dark mb-3 catalog-title">Catálogo de Drones</h1>
          <p class="lead text-secondary mx-auto" style="max-width: 48rem;">
            Drones profesionales DJI para inspección, mapeo, construcción y aplicaciones especializadas
          </p>
        </div>

        <!-- Brand Logos Section -->
        <div class="mb-4">
          <div class="d-flex flex-wrap align-items-center justify-content-center overflow-auto">
            <img
              src="public/images/pages/products/dji-agriculture-logo.png"
              alt="DJI Agriculture"
              class="img-fluid mx-3 mb-2"
              style="height: 2rem; width: auto; object-fit: contain; opacity: 0.7;"
            />
            <img
              src="public/images/pages/products/agrovias-logo.png"
              alt="Agrovías"
              class="img-fluid mx-3 mb-2"
              style="height: 2rem; width: auto; object-fit: contain; opacity: 0.7;"
            />
            <img
              src="public/images/pages/products/dji-enterprise-logo.png"
              alt="DJI Enterprise"
              class="img-fluid mx-3 mb-2"
              style="height: 2rem; width: auto; object-fit: contain; opacity: 0.7;"
            />
            <img
              src="public/images/pages/products/davis-logo.png"
              alt="Davis Instruments"
              class="img-fluid mx-3 mb-2"
              style="height: 2rem; width: auto; object-fit: contain; opacity: 0.7;"
            />
          </div>
        </div>

        <!-- Category Filters -->
        <!-- <div class="mb-4">
          <div class="d-flex flex-wrap justify-content-center">
            <button
              v-for="cat in categories"
              :key="cat"
              type="button"
              class="btn btn-sm mr-2 mb-2"
              :class="selectedCategory === cat ? 'btn-s1 text-white' : 'btn-outline-secondary'"
              :style="selectedCategory === cat ? { backgroundColor: '#4a7762', borderColor: '#4a7762' } : {}"
              @click="selectedCategory = cat"
            >
              {{ cat }}
            </button>
          </div>
        </div> -->

        <!-- Drones Grid -->
        <div class="row" v-if="!isLoading">
          <div
            v-for="(product, pInx) in drones"
            :key="'pInx-'+pInx"
            class="col-12 col-md-6 col-lg-4 mb-4 box-product-s2"
          >
            <router-link :to="'/drones/'+$root._converToURL(product.name, product.id)" class="text-decoration-none">
              <div class="card border-0 shadow catalog-product-card h-100">
                <div class="position-relative overflow-hidden catalog-product-img-wrap">
                  <img class="w-100 placed-backg" src="public/images/pages/products/product.png" v-bind:style="{ backgroundImage: 'url('+ (product.image ? product.image : 'public/images/pages/products/placeholder.svg') +')' }" />
                  <span class="badge badge-primary catalog-product-badge">{{ product.brand }}</span>
                  <div class="catalog-product-eye">
                    <span class="btn btn-sm btn-light">
                      <i class="fa-solid fa-eye"></i>
                    </span>
                  </div>

                  <div class="position-absolute" style="bottom: 1rem; right: 1rem;">
                    <span class="badge badge-success" v-if="product.stock == true">
                      En Stock
                    </span>
                    <span v-else class="badge badge-secondary">
                      Agotado
                    </span>
                  </div>
                </div>

                <div class="card-body">
                  <h3 class="card-title catalog-product-name mb-2">
                    {{ product.name }}
                  </h3>
                  <p class="text-muted small mb-3 p-short-description">{{ product.short_description }}</p>

                  <div class="d-flex flex-wrap mb-3 box-tags" v-html="$root.generateProdBadge(product.keywords)"></div>

                  <div class="d-flex align-items-center justify-content-between flex-wrap box-bottom">
                    <div class="col col-price">
                      <span class="d-block text-muted small text-decoration-line-through" v-if="product.price_offer">
                        $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} <small>USD</small>
                      </span>
                      <span class="catalog-product-price" v-if="product.price_offer">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_offer) }} <small>USD</small></span>
                      <span class="catalog-product-price" v-else>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} <small>USD</small></span>
                    </div>

                    <div class="col col-button">
                      <button
                        type="button"
                        class="btn btn-danger btn-sm w-100">
                        <i class="fa-solid fa-cart-shopping mr-1"></i>
                        Explorar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        
          <div class="col-12 col-pagination mt-2" v-if="!isLoading && drones.length > 0">
            <b-pagination-nav class="nav-pagination" :link-gen="linkGen" :number-of-pages="totalPages" use-router></b-pagination-nav>
          </div>
        </div>

        <loading-component-s1 v-if="isLoading"></loading-component-s1>

        <!-- No Results -->
        <div v-if="drones.length === 0 && !isLoading" class="text-center py-5">
          <p class="text-muted">No se encontraron drones que coincidan con tu búsqueda.</p>
        </div>

        <!-- Call to Action -->
        <div class="text-center mt-5">
          <h3 class="h4 font-weight-bold text-dark mb-3">¿Necesitas asesoría especializada?</h3>
          <p class="text-secondary mb-4">Nuestros expertos te ayudan a elegir el drone perfecto para tu proyecto</p>
          <router-link
            to="/contacto"
            class="btn btn-lg text-white"
            style="background-color: #4a7762;"
          >
            Contactar Especialista en Drones
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,

      filters: {
        page: 1,
      },

      totalPages: 1,

      categories: [/*'Todos', 'Seguridad', 'Accesorios'*/],
      drones: [
        // {
        //   id: 1,
        //   name: 'DJI Mavic 3 Enterprise',
        //   category: 'Inspección',
        //   price: '4,299.00',
        //   originalPrice: '4,799.00',
        //   image: 'public/images/pages/products/dji-mavic-3-enterprise.jpg',
        //   badge: 'Más Vendido',
        //   badgeColor: 'badge-danger',
        //   description: 'Drone profesional con cámara 4K y capacidades de inspección avanzadas',
        //   features: ['Cámara 4K', '56 min vuelo', '15km transmisión', 'IP54'],
        // },
        // {
        //   id: 2,
        //   name: 'DJI Avata 2',
        //   category: 'Inspección',
        //   price: '1,199.00',
        //   image: 'public/images/pages/products/dji-avata-2.png',
        //   badge: 'Nuevo',
        //   badgeColor: 'badge-success',
        //   description: 'Drone compacto para inspecciones en espacios reducidos',
        //   features: ['Protectores integrados', '4K/60fps', '18 min vuelo', 'Inmersivo'],
        // },
      ],
    };
  },
  
  methods: {
    getProducts: function(){
      this.filters.page = this.$route.query.page || 1;
      this.isLoading = true;

      axios.post(tools.url('/api/drones?page='+this.filters.page), this.filters).then(({data}) =>{
        this.drones = data.data;
        this.totalPages = data.last_page;
        this.isLoading = false;
      });
    },

    linkGen(pageNum) {
      return pageNum === 1 ? `?page=1` : `?page=${pageNum}`;
    },
  },

  mounted() {
    this.getProducts();
  },

  watch: {
    $route(to, from) {
      this.getProducts();
    }
  },
};
</script>